import React from 'react';
import PropTypes from 'prop-types';
import { withStyles } from '@material-ui/core/styles';
import green from '@material-ui/core/colors/green';
import { FormControlLabel } from '@material-ui/core';
import Switch from '@material-ui/core/Switch';

const styles = {
  checked: {
    color: green[500],
    '& + $bar': {
      backgroundColor: green[500],
    },
  },
  bar: {},
};

class CheckBox extends React.Component {


  handleChange = event => {
    // this.setState({ [name]: event.target.checked });
    const field = this.props.field
    const jData = {
      [field]: event.target.checked
    }
    this.props.onChange(this.props.id, jData)
  }

  render() {
    const { classes } = this.props;
    const { access } = this.props;
    return (

      <FormControlLabel
        label={(this.props.value === true) ? 'Так' : 'Ні'}
        control={
          <Switch
            disabled={(access.edit) ? false : true}
            checked={this.props.value}
            onChange={this.handleChange}
            value="checkedF"
            classes={{
              checked: classes.checked,
              bar: classes.bar,
            }}
          />
        }
      />



    );
  }
}

CheckBox.propTypes = {
  classes: PropTypes.object.isRequired,
};

export default withStyles(styles)(CheckBox)


// WEBPACK FOOTER //
// ./src/components/FormComponent/SwitchBox.js